import { toMoney } from '@utils/Format'
import { MASK_BRL, MASK_USD } from '@modules/global/constants/Currencies'

export const getCurrencyByInvestmentType = ({ investmentType }) => {
  const normalizedValue = normalizeInvestmentType({ investmentType })
  const isOffshore = normalizedValue.includes('offshore')
  if (isOffshore) return 'dol'
  return 'real'
}

export const getChartCurrencyCodeByInvestmentType = ({ investmentType }) => {
  const normalizedValue = normalizeInvestmentType({ investmentType })
  const isOffshore = normalizedValue.includes('offshore')
  if (isOffshore) return 'USD'
  return 'BRL'
}

export const isOffshoreInvestmentType = ({ investmentType }) => {
  const normalizedValue = normalizeInvestmentType({ investmentType })
  return normalizedValue.includes('offshore')
}

export const isOnshoreInvestmentType = ({ investmentType }) => {
  const normalizedValue = normalizeInvestmentType({ investmentType })
  return normalizedValue.includes('onshore')
}

export const getMoneySymbolByCurrency = ({ currencyKey }) => {
  const normalizedKey = String(currencyKey || '')
    .trim()
    .toLowerCase()

  if (normalizedKey === 'dol') return MASK_USD
  return MASK_BRL
}

export const getMoneySymbolByInvestmentType = ({ investmentType }) => {
  const currencyKey = getCurrencyByInvestmentType({ investmentType })
  return getMoneySymbolByCurrency({ currencyKey })
}

export const formatRentabilityByCurrency = ({
  rawValue,
  currencyKey,
  fallbackValue,
}) => {
  const hasNumberValue = typeof rawValue === 'number'
  if (!hasNumberValue) return fallbackValue || ''

  const normalizedCurrency = String(currencyKey || '')
    .trim()
    .toLowerCase()

  if (normalizedCurrency === 'dol') {
    return toMoney(rawValue, 2, 'dol')
  }

  if (fallbackValue) return fallbackValue

  return toMoney(rawValue, 2, normalizedCurrency || 'real')
}

export const normalizeInvestmentType = ({ investmentType }) => {
  const rawValue = String(investmentType || '')
  const trimmedValue = rawValue.trim()
  const normalizedValue = trimmedValue.toLowerCase()
  return normalizedValue
}
